import React, { useContext } from 'react'
import { ConfigContext } from './Store/ConfigContext'
// Routs
import { BrowserRouter } from 'react-router-dom'
import styled from '@emotion/styled'
// App Theme
// Internal Components
import Routes from './Routes'
import AlertDialog from './Components/Common/AlertDialog'
import CSTNavbar from './Components/Common/CSTNavbar'

const AppWrapper = styled('div')(({ theme }) => ({
  padding: '0px',
  display: 'flex',
  justifyItems: 'center',
  width: '100%',
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    display: 'block',
  },
}))

const ConfigWrapper = (props) => {
  const { clientName } = useContext(ConfigContext)

  return (
    <>
      {clientName === 'cst' && <CSTNavbar />}
      <AppWrapper>
        <AlertDialog />
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </AppWrapper>
    </>
  )
}

export default ConfigWrapper
